module.exports = __webpack_public_path__ + "static/media/13(2).dc1ab77a.jpg";